// phoneNumber format: 55996737066
export const getWhatsappLink = (phoneNumber, message) => {
  const baseUrl = 'https://wa.me/'
  const messageEncoded = encodeURIComponent(message)

  return `${baseUrl}/55${phoneNumber}?text=${messageEncoded}`
}
